export type ManagedMerchant = {
    managedMerchantsId: number | null;
    widgetClientsId: number | null;
    merchantName: string;
    domain: string;
    statementDescriptor: string;
    contactEmail: string | null;
    gatewayUsername: string | null;
    settlementWalletAddress: string;
    status: 'Pending' | 'Active' | 'Suspended';
    lastError: string | null;
    apiKey: string | null;
    secretRegeneratedDate: string | null;
    addDate: string;
};

export type MerchantCredentials = {
    managedMerchantsId?: number | null;
    widgetClientsId?: number | null;
    apiKey?: string | null;
    hashSecret: string;
    gatewayUsername?: string | null;
    gatewayLoginEmail?: string | null;
};

export type MerchantCreateDetails = {
    defaultSettlementWalletAddress: string | null;
    completeWebhookUrlTemplate: string | null;
    transferWebhookUrlTemplate: string | null;
    settlementAssetCode: string | null;
};

export type MerchantFormValues = {
    merchantName: string;
    domain: string;
    statementDescriptor: string;
    contactEmail: string;
    contactFirstName: string;
    contactLastName: string;
    settlementWalletAddress: string;
    completeWebhookUrl: string;
    transferWebhookUrl: string;
};

export const PAYMENT_SETUP_PENDING = 'Merchant_Payment_Setup_Pending';

const MERCHANT_ERROR_MESSAGES: Record<string, string> = {
    Already_Exists: 'A merchant with this website already exists.',
    Invalid_Access: 'You do not have access to merchant management.',
    Merchant_Template_Not_Configured: 'Merchant set up is not available yet. Please contact support.',
    Merchant_Setup_Failed:
        'The merchant was saved but its set up is not finished. Please retry from the merchant list.',
    [PAYMENT_SETUP_PENDING]:
        'The merchant was created and its portal login was emailed. Payments are being enabled, retry from the merchant list later to get the QuickBuy keys.',
    Merchant_Already_Active: 'This merchant is already active.',
    Invalid_Format: 'The format is not valid.',
    Required: 'This field is required.',
    Invalid: 'This value is not valid.',
};

export const GENERIC_MERCHANT_ERROR = 'There was an error. Please try again later.';

export const merchantErrorMessage = (messageCode?: string) =>
    (messageCode && MERCHANT_ERROR_MESSAGES[messageCode]) || GENERIC_MERCHANT_ERROR;

export const apiErrors = (ex: any): { fieldName?: string; messageCode?: string }[] =>
    ex?.response?.data?.errors ?? [];

export const normalizeDomain = (value: string) => {
    let host = (value ?? '').trim().toLowerCase();
    if (!host) return '';
    host = host.replace(/^[a-z]+:\/\//, '').split('/')[0].split('?')[0].split(':')[0];
    return host.startsWith('www.') ? host.substring(4) : host;
};

export const copyToClipboard = async (value: string) => {
    try {
        await navigator.clipboard.writeText(value);
        return true;
    } catch {
        return false;
    }
};
